/**
 * A 5ª ponte: o simulador portado guardando o arquivo anexado.
 *
 * PARA QUE ISTO EXISTE
 * Os modais "Anexar MCV" e "Anexar MVT" são da v67 e sempre foram MOCK: o arquivo era
 * escolhido, o botão fabricava valores e o arquivo ia para o lixo com a página. Agora
 * ele é guardado de verdade. A EXTRAÇÃO continua simulada — decisão de 29/07/2026.
 *
 * ⚠ REGRA DURA: `simulador.js` NÃO pode virar módulo ES (`lote()` troca funções em
 * `window` em tempo de execução). Por isso o envio não é um `import` lá dentro: é uma
 * função pendurada em `window.__fincastDocs`, como as outras quatro pontes.
 *
 * ⚠ O simulador chama e SEGUE EM FRENTE. O envio é assíncrono e pode demorar 20 MB; a
 * extração dos valores é instantânea e não depende dele. Travar a tela até o arquivo
 * subir trocaria uma simulação imediata por uma espera — e o resultado da extração
 * seria o mesmo. O aviso de sucesso ou de falha chega quando chegar.
 */
import { enviarDocumento, motivoDeRecusa } from '../../../../packages/dados/src/documentos';
import type { TipoDocumento } from '../../../../packages/dados/src/documentos';
import { avisar } from '../ui/aviso';

/** O que só a casca sabe: de qual empreendimento (e cenário) o simulador está tratando. */
export interface ContextoDocumentos {
  empresaId: string;
  empreendimentoId: string;
  cenarioId: string | null;
}

let ctx: ContextoDocumentos | null = null;

/** Chamada pela montagem, antes de o script legado carregar. */
export function configurarDocumentos(c: ContextoDocumentos): void {
  ctx = c;
}

/**
 * Guarda o arquivo escolhido num dos modais de anexo.
 *
 * Não lança: o simulador é código legado sem tratamento de erro nas bordas, e uma
 * exceção aqui interromperia a extração dos valores — que é o que o usuário pediu ao
 * clicar. Falha vira aviso na tela.
 */
export function guardar(tipo: TipoDocumento, arquivo: File | null | undefined): void {
  if (!arquivo) return;
  if (ctx === null) {
    avisar('Não consegui identificar o empreendimento para guardar o arquivo.', 'erro');
    return;
  }
  const recusa = motivoDeRecusa(arquivo);
  if (recusa !== null) {
    avisar(recusa, 'erro');
    return;
  }
  const alvo = ctx;
  void enviarDocumento({
    empresaId: alvo.empresaId,
    empreendimentoId: alvo.empreendimentoId,
    cenarioId: alvo.cenarioId,
    tipo,
    arquivo,
  }).then(
    (d) => avisar(`"${d.nome}" foi guardado nos documentos do empreendimento.`, 'ok'),
    (e: unknown) => avisar(e instanceof Error ? e.message : 'Não consegui guardar o arquivo.', 'erro'),
  );
}
